<template>
  <v-row
    v-if="overview"
    dense
    class="mt-2"
  >
    <v-col
      cols="12"
      md="6"
    >
      <v-card
        elevation="2"
        rounded="lg"
      >
        <v-card-title class="text-subtitle-2 py-2 d-flex align-center">
          Top workspaces (period)
          <v-spacer />
          <v-btn
            v-if="overview.top_workspaces.length > PREVIEW"
            x-small
            text
            color="primary"
            @click="expandedWS = !expandedWS"
          >
            <v-icon x-small left>
              {{ expandedWS ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
            {{ expandedWS ? 'Show less' : `+${overview.top_workspaces.length - PREVIEW} more` }}
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <service-breakdown-list
            :items="expandedWS ? overview.top_workspaces : overview.top_workspaces.slice(0, PREVIEW)"
            empty-label="No workspace data"
          />
        </v-card-text>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <v-card
        elevation="2"
        rounded="lg"
      >
        <v-card-title class="text-subtitle-2 py-2 d-flex align-center">
          Calls by service
          <v-spacer />
          <v-btn
            v-if="overview.by_service.length > PREVIEW"
            x-small
            text
            color="primary"
            @click="expandedService = !expandedService"
          >
            <v-icon x-small left>
              {{ expandedService ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
            {{ expandedService ? 'Show less' : `+${overview.by_service.length - PREVIEW} more` }}
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <service-breakdown-list
            :items="expandedService ? overview.by_service : overview.by_service.slice(0, PREVIEW)"
            empty-label="No service data"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
const PREVIEW = 3;

export default {
  name: 'GlobalBreakdownCards',
  components: {
    ServiceBreakdownList: () => import('@/components/statistics/ServiceBreakdownList')
  },
  props: {
    overview: { type: Object, default: null }
  },
  data() {
    return {
      PREVIEW,
      expandedWS: false,
      expandedService: false
    };
  }
};
</script>
